import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import index from '../views/index.vue'
import Show from '../views/Show.vue'
import cgzp from '../views/cgzp.vue'
import lwzp from '../views/lwzp.vue'
import hjcx from '../views/hjcx.vue'
import hjcxPhone from '../views/hjcxPhone.vue'
import hjcxcgPhone from '../views/hjcxcgPhone.vue'
import bmcs from '../views/bmcs.vue'
import Home from '../views/ysj/Home.vue'
import course from '../views/ysj/course.vue'
import courseInfo from '../views/ysj/courseInfo.vue'
import activity from '../views/ysj/activity.vue'
import yanjaing from '../views/ysj/yanjaing.vue'
import addUserInfo from '../views/ysj/addUserInfo.vue'
import myInfo from '../views/ysj/myInfo.vue'
import myFile from '../views/ysj/myFile.vue'
import userInfo from '../views/ysj/userInfo.vue'
//import lwList from '../views/xsk/lwList.vue'
import lwList from '../views/lwList.vue'
//import upLoadlw from '../views/xsk/upLoadlw.vue'
//import wxPay from '../views/xsk/wxPay.vue'
import wxPay from '../views/wxPay.vue'
//import cgList from '../views/xsk/cgList.vue'
import cgList from '../views/cgList.vue'
//import upLoadcg from '../views/xsk/upLoadcg.vue'
import upLoadcg from '../views/upLoadcg.vue'
import upLoadlw from '../views/upLoadlw.vue'
import xgLoadlw from '../views/xgLoadlw.vue'
import xgLoadcg from '../views/xgLoadcg.vue'
import userHome from '../views/userHome.vue'
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Index',
    component: Login
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/show',
    name: 'Show',
    component: Show
  },
  {
    path: '/cgzp',
    name: 'cgzp',
    component: cgzp
  },
  {
    path: '/lwzp',
    name: 'lwzp',
    component: lwzp
  },
  {
    path: '/hjcx',
    name: 'hjcx',
    component: hjcx
  },
  {
    path: '/bmcs',
    name: 'bmcs',
    component: bmcs
  },
  {
    path: '/ysj/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/ysj/course',
    name: 'course',
    component: course
  },
  {
    path: '/ysj/courseInfo',
    name: 'courseInfo',
    component: courseInfo
  },
  {
    path: '/ysj/activity',
    name: 'activity',
    component: activity
  },
  {
    path: '/ysj/yanjaing',
    name: 'yanjaing',
    component: yanjaing
  },
  {
    path: '/ysj/addUserInfo',
    name: 'addUserInfo',
    component: addUserInfo
  },
  {
    path: '/ysj/myInfo',
    name: 'myInfo',
    component: myInfo
  },
  {
    path: '/ysj/myFile',
    name: 'myFile',
    component: myFile
  },
  {
    path: '/ysj/userInfo',
    name: 'userInfo',
    component: userInfo
  },
  {
    path: '/lwList',
    name: 'lwList',
    component: lwList
  },
  {
    path: '/upLoadlw',
    name: 'upLoadlw',
    component: upLoadlw
  },
  {
    path: '/xgLoadlw',
    name: 'xgLoadlw',
    component: xgLoadlw
  },
  {
    path: '/xgLoadcg',
    name: 'xgLoadcg',
    component: xgLoadcg
  },
  {
    path: '/wxPay',
    name: 'wxPay',
    component: wxPay
  },
  {
    path: '/cgList',
    name: 'cgList',
    component: cgList
  },
  {
    path: '/hjcxPhone',
    name: 'hjcxPhone',
    component: hjcxPhone
  },
  {
    path: '/hjcxcgPhone',
    name: 'hjcxcgPhone',
    component: hjcxcgPhone
  },
  
  {
    path: '/upLoadcg',
    name: 'upLoadcg',
    component: upLoadcg
  },
  {
    path: '/userHome',
    name: 'userHome',
    component: userHome
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
